"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointTransformationOut = void 0;
class EndpointTransformationOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EndpointTransformationOut.attributeTypeMap;
    }
}
exports.EndpointTransformationOut = EndpointTransformationOut;
EndpointTransformationOut.discriminator = undefined;
EndpointTransformationOut.attributeTypeMap = [
    {
        "name": "code",
        "baseName": "code",
        "type": "string",
        "format": ""
    },
    {
        "name": "enabled",
        "baseName": "enabled",
        "type": "boolean",
        "format": ""
    }
];
//# sourceMappingURL=EndpointTransformationOut.js.map